export const Main = (r) => require.ensure([], () => r(require("../../Core/components/Main")), "Config-bundle")
export const ListMcc = (r) => require.ensure([], () => r(require("../components/mcc/ListMcc")), "Config-bundle")
export const ListLojista = (r) => require.ensure([], () => r(require("../components/Lojista/ListLojista")), "Config-bundle")
export const EditNewLojista = (r) => require.ensure([], () => r(require("../components/Lojista/EditNewLojista")), "Config-bundle")
export const ListBank = (r) => require.ensure([], () => r(require("../components/banco/ListBank")), "Config-bundle")
export const ListPhoneOperator = (r) => require.ensure([], () => r(require("../components/phoneOperator/ListPhoneOperator")), "Config-bundle")
export const ListAcceptTerm = (r) => require.ensure([], () => r(require("../components/AcceptTerm/ListAcceptTerm")), "Config-bundle")
export const ListHoliday = (r) => require.ensure([], () => r(require("../components/holiday/ListHoliday")), "Config-bundle")
export const ListCardBrand = (r) => require.ensure([], () => r(require("../components/CardBrand/ListCardBrand")), "Config-bundle")
export const EditNewCardBrand = (r) => require.ensure([], () => r(require("../components/CardBrand/EditNewCardBrand")), "Config-bundle")
export const ListCustosOperacionais = (r) => require.ensure([], () => r(require("../components/CustosOperacionais/ListCustosOperacionais")), "Config-bundle")
export const ListApiClient = (r) => require.ensure([], () => r(require("../components/ApiClient/ListApiClient")), "Config-bundle")
export const ViewApiClient = (r) => require.ensure([], () => r(require("../components/ApiClient/ViewApiClient")), "Config-bundle")
export const ListMigracao = (r) => require.ensure([], () => r(require("../components/Migracao/ListMigracao")), "Config-bundle")
export const EditMigracoes = (r) => require.ensure([], () => r(require("../components/Migracao/EditMigracoes")), "Config-bundle")
export const CreateMigracoes = (r) => require.ensure([], () => r(require("../components/Migracao/CreateMigracoes")), "Config-bundle")
export const ListPaymentAdjustType = (r) => require.ensure([], () => r(require("../components/paymentAdjustType/ListPaymentAdjustType")), "Config-bundle")
export const ListAuthProfile = (r) => require.ensure([], () => r(require("../components/ProfilePermission/ListAuthProfile")), "Config-bundle")
export const FormAuthProfile = (r) => require.ensure([], () => r(require("../components/ProfilePermission/FormAuthProfile")), "Config-bundle")

const children = [
	{
		name: "config.apiclient.index",
		path: "api-client",
		component: ListApiClient,
		meta: {
			requiresAuth: true,
			title: "Listagem de Api Client",
			titleMenu: "Api Client",
			permission: "owner|public",
			breadcrumbs: [
				{
					name: "Listagem de Api Client",
					pathName: "config.apiclient.index"
				}
			]
		}
	},
	{
		name: "integration.apiclient.view",
		path: "client-api",
		component: ViewApiClient,
		meta: {
			requiresAuth: true,
			title: "Visualizar Api Client",
			titleMenu: "Token de Acesso",
			permission: "owner|public",
			breadcrumbs: [
				{
					name: "Visualizar de Api Client",
					pathName: "integration.apiclient.view"
				}
			]
		}
	},

	{
		name: "config.custooperacionais.index",
		path: "custo-operacionais",
		component: ListCustosOperacionais,
		meta: {
			requiresAuth: true,
			title: "Listagem de Custos Operacionais",
			titleMenu: "Custos Operacionais",
			permission: "owner|public",
			breadcrumbs: [
				{
					name: "Listagem de Custos Operacionais",
					pathName: "config.custooperacionais.index"
				}
			]
		}
	},
	{
		name: "config.payment-adjust-type.index",
		path: "payment-adjust-type",
		component: ListPaymentAdjustType,
		meta: {
			requiresAuth: true,
			title: "Listagem de Tipos de Ajuste",
			titleMenu: "Tipos de Ajuste",
			permission: "owner|public",
			breadcrumbs: [
				{
					name: "Listagem dos tipos de Ajustes",
					pathName: "config.payment-adjust-type.index"
				}
			]
		}
	},
	{
		name: "config.lojista.index",
		path: "grupo-lojista",
		component: ListLojista,
		meta: {
			requiresAuth: true,
			title: "Listagem de grupo de logistas",
			titleMenu: "Grupo de lojista",
			permission: "owner|public",
			breadcrumbs: [
				{
					name: "Listagem de grupo de lojistas",
					pathName: "config.lojista.index"
				}
			]
		}
	},
	{
		name: "config.lojista.create",
		path: "grupo-lojista/adicionando",
		component: EditNewLojista,
		meta: {
			requiresAuth: true,
			title: "Adicionando grupo de lojistas",
			titleMenu: "Grupo de logista",
			permission: "owner|public",
			breadcrumbs: [
				{
					name: "Listagem de grupo de lojistas",
					pathName: "config.lojista.index"
				},
				{
					name: "Adicionando grupo de lojistas",
					pathName: "config.lojista.index"
				}
			]
		}
	},
	{
		name: "config.lojista.edit",
		path: "grupo-lojista/:id",
		component: EditNewLojista,
		meta: {
			requiresAuth: true,
			title: "Adicionando grupo de lojistas",
			titleMenu: "Grupo de logista",
			permission: "owner|public",
			breadcrumbs: [
				{
					name: "Listagem de grupo de lojistas",
					pathName: "config.lojista.index"
				},
				{
					name: "Editando grupo de lojistas",
					pathName: "config.lojista.edit"
				}
			]
		}
	},
	{
		name: "config.mcc.index",
		path: "mcc",
		component: ListMcc,
		meta: {
			requiresAuth: true,
			title: "Listagem de MCC",
			titleMenu: "MCC",
			permission: "owner|public",
			breadcrumbs: [
				{
					name: "Listagem de MCC",
					pathName: "config.mcc.index"
				}
			]
		}
	},
	{
		name: "config.bank.index",
		path: "bancos",
		component: ListBank,
		meta: {
			requiresAuth: true,
			title: "Listagem de Bancos",
			titleMenu: "Bancos",
			permission: "owner|public",
			breadcrumbs: [
				{
					name: "Listagem de Bancos",
					pathName: "config.bank.index"
				}
			]
		}
	},
	{
		name: "config.phoneOperator.index",
		path: "operadoras-moveis",
		component: ListPhoneOperator,
		meta: {
			requiresAuth: true,
			title: "Listagem de Operadoras Móveis",
			titleMenu: "Operadoras Móveis",
			permission: "owner|public",
			breadcrumbs: [
				{
					name: "Listagem de Operadoras Móveis",
					pathName: "config.phoneOperator.index"
				}
			]
		}
	},
	{
		name: "config.AcceptTerm.index",
		path: "termos_de_aceite",
		component: ListAcceptTerm,
		meta: {
			requiresAuth: true,
			title: "Listagem de Termos de aceite",
			titleMenu: "Termos de aceite",
			permission: "owner|public",
			breadcrumbs: [
				{
					name: "Listagem de termos de aceite",
					pathName: "config.AcceptTerm.index"
				}
			]
		}
	},
	{
		name: "config.holiday.index",
		path: "feriados",
		component: ListHoliday,
		meta: {
			requiresAuth: true,
			title: "Listagem de Feriados",
			titleMenu: "Feriados",
			permission: "owner|public",
			breadcrumbs: [
				{
					name: "Listagem de Feriados",
					pathName: "config.holiday.index"
				}
			]
		}
	},
	{
		name: "config.cardbrand.index",
		path: "bandeiras",
		component: ListCardBrand,
		meta: {
			requiresAuth: true,
			title: "Listagem de Bandeiras",
			titleMenu: "Bandeiras",
			permission: "owner|public",
			breadcrumbs: [
				{
					name: "Listagem de Bandeiras",
					pathName: "config.cardbrand.index"
				}
			]
		}
	},
	{
		name: "config.cardbrand.create",
		path: "bandeiras/adicionando",
		component: EditNewCardBrand,
		meta: {
			requiresAuth: true,
			title: "Adicionando Bandeira",
			titleMenu: "Bandeiras",
			permission: "owner|public",
			breadcrumbs: [
				{
					name: "Listagem de Bandeiras",
					pathName: "config.cardbrand.index"
				},
				{
					name: "Adicionando Bandeira",
					pathName: "config.cardbrand.create"
				}
			]
		}
	},
	{
		name: "config.cardbrand.edit",
		path: "bandeiras/:id",
		component: EditNewCardBrand,
		meta: {
			requiresAuth: true,
			title: "Editando Bandeira",
			titleMenu: "Bandeiras",
			permission: "owner|public",
			breadcrumbs: [
				{
					name: "Listagem de Bandeiras",
					pathName: "config.cardbrand.index"
				},
				{
					name: "Editando Bandeira",
					pathName: "config.cardbrand.edit"
				}
			]
		}
	},
	{
		name: "config.ListMigracoes.index",
		path: "migracoes",
		component: ListMigracao,
		meta: {
			requiresAuth: true,
			title: "Listagem de Migrações",
			titleMenu: "Migrações",
			permission: "owner|public",
			breadcrumbs: [
				{
					name: "Listagem de Migrações",
					pathName: "config.ListMigracoes.index"
				}
			]
		}
	},
	{
		name: "config.ListMigracoes.create",
		path: "migracoes/adicionando",
		component: CreateMigracoes,
		meta: {
			requiresAuth: true,
			title: "Adicionando Migração",
			titleMenu: "Migrações",
			permission: "owner|public",
			breadcrumbs: [
				{
					name: "Listagem de Migrações",
					pathName: "config.ListMigracoes.index"
				}
			]
		}
	},
	{
		name: "config.ListMigracoes.edit",
		path: "migracoes/:id",
		component: EditMigracoes,
		meta: {
			requiresAuth: true,
			title: "Editando Migração",
			titleMenu: "Migrações",
			permission: "owner|public",
			breadcrumbs: [
				{
					name: "Listagem de Migrações",
					pathName: "config.ListMigracoes.index"
				},
				{
					name: "Editando Migrações",
					pathName: "config.ListMigracoes.edit"
				}
			]
		}
	},
	{
		name: "config.auth_profile.index",
		path: "auth_profile",
		component: ListAuthProfile,
		meta: {
			requiresAuth: true,
			title: "Listagem de Perfis de Acesso",
			titleMenu: "Perfis de Acesso",
			permission: "owner|public",
			breadcrumbs: [
				{
					name: "Listagem de Perfis de Acesso",
					pathName: "config.auth_profile.index"
				}
			]
		}
	},
	{
		name: "config.auth_profile.create",
		path: "auth_profile/create",
		component: FormAuthProfile,
		meta: {
			requiresAuth: true,
			title: "Adicionando Perfil de Acesso",
			permission: "owner|public",
			breadcrumbs: [
				{
					name: "Listagem de Perfis de Acesso",
					pathName: "config.auth_profile.index"
				},
				{
					name: "Adicionando Perfil de Acesso",
					pathName: "config.auth_profile.create"
				}
			]
		}
	},
	{
		name: "config.auth_profile.edit",
		path: "auth_profile/:id",
		component: FormAuthProfile,
		meta: {
			requiresAuth: true,
			title: "Editando Perfil de Acesso",
			permission: "owner|public",
			breadcrumbs: [
				{
					name: "Listagem de Perfis de Acesso",
					pathName: "config.auth_profile.index"
				},
				{
					name: "Editando Perfil de Acesso",
					pathName: "config.auth_profile.edit"
				}
			]
		}
	},
]

export default [
	{
		name: "config",
		children,
		path: "/configuracao",
		component: Main,
		redirect: { name: "home.index" },
		meta: {
			requiresAuth: true
		}
	}
]
